import { User, FirebaseUserData } from '../../models/user.interface';

/**
 * AuthState semplificato - gestisce solo lo stato di autenticazione e i dati utente
 */
export interface AuthState {
  user: User | null;
  firebaseUser: FirebaseUserData | null; // Dati temporanei da Firebase prima del caricamento backend
  isLoading: boolean;
  isInitialized: boolean; // True quando Firebase ha fatto il primo check
  error: string | null;
}

export const initialAuthState: AuthState = {
  user: null,
  firebaseUser: null,
  isLoading: false,
  isInitialized: false, // Parte come false finché Firebase non verifica
  error: null
};
